import styled from 'styled-components';

const SetUpAutopayCardWrapper = styled.div`
  align-content: center;
  border: 1px solid #d9dde9;
  border-radius: 8px;
  background-color: ${(props) => props.theme.color.neutral.v100};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family: 'Brandon Text';
  justify-content: center;
  padding: 25px;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  width: 100%;
  height: 100%;
  margin: 0 auto 16px auto;
  max-width: 912px;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-width: 325px;
    justify-content: flex-start;
  }

  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-height: 410px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    min-height: auto;
    padding: 40px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.xl}px) {
    min-height: 320px;
  }
`;

const SetUpAutopayTitle = styled.h2`
  color: ${(props) => props.theme.color.primary.v600};
  padding: 0 0 24px 0;
  margin: 0 auto;
  font-size: 20px;
  line-height: 24px;
  max-width: 912px;
  width: 100%;
`;

const HR = styled.hr`
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  width: 100%;
  border-bottom-color: transparent;
`;

export { SetUpAutopayCardWrapper, SetUpAutopayTitle, HR };
